import * as stateHelpers from 'app/react/state/helpers';
import * as actions from 'app/react/state/actions/_index';

export const ID = 'deleteVehicleModal';

const ERROR_POPUP = 'Failed to delete vehicle.';
const SUCCESSFUL_POPUP = (make, model) =>
    `Vehicle <strong>${make}</strong> <strong>${model}</strong> successfully deleted.`;

export const getState = (state) =>
    stateHelpers.getComponentState(state, ID) || {};

export const mergeState = (newState) =>
    actions.mergeComponentState(ID, newState);

export const setStateValue = (key, value) =>
    actions.setComponentStateValue(ID, key, value);

export const open = (vehicle) => mergeState({
    isOpened: true,
    vehicle
});

export const close = () => mergeState({
    isOpened: false,
    isSyncing: false,
});

export const showSuccessPopup = (make, modal) =>
    actions.showSuccessPopup(SUCCESSFUL_POPUP(make, modal));

export const showErrorPopup = (key) =>
    actions.showErrorPopup(ERROR_POPUP);
